import { LIGHT_COLOR_MAP, GRID_SIZE } from '@utils/game/zenBlocks/constants.js';
export default {
  name: "PlacementHint",
  props: {
    activeBlock: {
      type: Object,
      required: true // 外部传入的小方块的二维形状
    },

    grid: {
      type: Array,
      default: () => []
    },
    dragPos: {
      type: Object,
      default: () => ({
        x: 0,
        y: 0
      })
    },
    boardRect: {
      type: [Object, DOMRect],
      default: () => ({})
    }
  },
  watch: {
    dragPos: {
      handler(newVal, oldVal) {
        if (!this.activeBlock) {
          this.canPlace = false;
          return null;
        }
        const cellSize = this.boardRect.width / this.GRID_SIZE;
        const x = this.dragPos.x - this.boardRect.left;
        const y = this.dragPos.y - this.boardRect.top;
        const pieceWidth = this.activeBlock.block.shape[0].length * cellSize;
        const pieceHeight = this.activeBlock.block.shape.length * cellSize;
        const col = Math.round((x - pieceWidth / 2) / cellSize);
        const row = Math.round((y - pieceHeight / 2) / cellSize);
        const isValid = col >= 0 && row >= 0 && col + this.activeBlock.block.shape[0].length <= this.GRID_SIZE && row + this.activeBlock.block.shape.length <= this.GRID_SIZE;
        if (!isValid) return null;
        let canPlace = true;
        for (let r = 0; r < this.activeBlock.block.shape.length; r++) {
          for (let c = 0; c < this.activeBlock.block.shape[0].length; c++) {
            if (this.activeBlock.block.shape[r][c] && this.grid[row + r][col + c] !== null) {
              canPlace = false;
              break;
            }
          }
        }
        this.pieceWidth = pieceWidth;
        this.pieceHeight = pieceHeight;
        this.cellSize = cellSize;
        this.col = col;
        this.row = row;
        this.canPlace = canPlace;
      },
      deep: true,
      // 如果是对象或数组必须加 deep
      immediate: true // 初始化时立即执行一次 handler
    }
  },

  data() {
    return {
      GRID_SIZE,
      LIGHT_COLOR_MAP,
      canPlace: false,
      col: 0,
      row: 0,
      pieceWidth: 0,
      pieceHeight: 0,
      cellSize: 0
    };
  },
  computed: {
    flatShape() {
      return this.activeBlock.block.shape.flatMap((rArr, r) => rArr.map((cell, c) => ({
        r,
        c,
        cell
      })));
    }
  }
};